import type { ManagedCall } from '@repo/sdk/gen'
import { makeBreadcrumbFromCache } from '@repo/ui/components/query-breadcrumbs'
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router'
import { makeQueryKeys } from '@/query/query-keys'
import { managedCallQueryOptions } from '../../bando/-query/query-options'
import { residenceDetailQueryOptions } from '../../residences/-query/query-options'

export const Route = createFileRoute('/(private)/strutture/$residenceId')({
	loader: async ({ context, params }) => {
		try {
			// Show what is cached at once, and read the residence again if it is stale.
			await Promise.all([
				context.queryClient.ensureQueryData({
					...managedCallQueryOptions(params.residenceId),
					revalidateIfStale: true
				}),
				context.queryClient.ensureQueryData({
					...residenceDetailQueryOptions(params.residenceId),
					revalidateIfStale: true
				})
			])
		} catch (error) {
			// Another manager's residence answers as if it did not exist.
			if (
				typeof error === 'object' &&
				error !== null &&
				'code' in error &&
				error.code === 'residence_not_found'
			) {
				throw notFound()
			}
			throw error
		}
	},
	staticData: {
		breadcrumb: ({ params, queryClient }) =>
			makeBreadcrumbFromCache<ManagedCall>(
				queryClient,
				makeQueryKeys.call.managed(params.residenceId ?? ''),
				(myCall) => myCall.residence.name
			)
	},
	component: () => <Outlet />
})
